import React from 'react';
import { Link } from 'react-router-dom';

function badgeCls(days) {
  if (days <= 7) return 'bg-red-100 text-red-700';
  if (days <= 14) return 'bg-yellow-100 text-yellow-800';
  return 'bg-green-100 text-green-700';
}

export default function InsuranceExpiring({ items = [], loading }) {
  return (
    <div className="bg-white border border-gray-100 rounded-2xl shadow-sm">
      <div className="flex justify-between items-center px-5 pt-4 pb-2 border-b-2 border-brand-primary">
        <h3 className="text-xs font-extrabold uppercase tracking-wider text-brand-secondary">
          Insurance Expiring
        </h3>
        <Link to="/insurance/fleet" className="text-xs font-semibold text-brand-primary">
          View all →
        </Link>
      </div>
      <div className="px-5 py-3 space-y-2">
        {loading ? (
          <p className="text-xs text-gray-400 py-2">Loading...</p>
        ) : items.length === 0 ? (
          <p className="text-xs text-gray-400 py-2">No insurance expiring soon.</p>
        ) : (
          items.map((record, i) => (
            <div key={i} className="flex items-center justify-between py-1 border-b border-gray-50 last:border-b-0">
              <div className="min-w-0">
                <span className="text-xs font-bold text-brand-secondary uppercase tracking-wide">
                  {record.plate_no}
                </span>
                {record.insurance_company_name && (
                  <span className="text-xs text-gray-500 ml-2">{record.insurance_company_name}</span>
                )}
              </div>
              <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full ml-2 shrink-0 ${badgeCls(record.days_until_expiry)}`}>
                {record.days_until_expiry} days
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
